// extracted by mini-css-extract-plugin
export default {"multi":"multi-K9Ag","token":"token-IUgz","input":"input-Utix","content":"content-gmNs","close":"close-kBsL","icon":"icon-IS5D","title":"title-Pd8h"};